import { render } from "./updateperson.vue?vue&type=template&id=aa52066e&scoped=true"
import script from "./updateperson.vue?vue&type=script&lang=js"
export * from "./updateperson.vue?vue&type=script&lang=js"

import "./updateperson.vue?vue&type=style&index=0&id=aa52066e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa52066e"]])

export default __exports__